import { REDIRECT_URL_PARAM } from "@nf/constants";
import { useMemo } from "react";

import { useRouter } from "./useRouter";

export const useRedirectUrlParam = () => {
  const { query } = useRouter();
  const redirectUrl = query[REDIRECT_URL_PARAM];

  return useMemo(() => redirectUrl, [redirectUrl]);
};
